import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AccordionItem } from './AccordionItem';
import { fromRelativeUrlToAbsoluteUrl } from '../../../../utils/locationUtils';
import { examplesOpenClose } from '../../../LoggerFactory/BiAnalyticsLogger/events';
import { LoggerContext } from '../../../appContext/LoggerProvider';
import { LOGGER_TYPES } from '../../../LoggerFactory/loggerTypes';
import { TOGGLE_EXAMPLES_ACTIONS } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import {
  getArticleNameFromPathname,
  getCategoryNameFromPathname,
} from '../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { StoreContext } from '../../../appContext/StoreProvider';

export const Accordion = React.memo(
  ({
    data,
    dataHook,
    shouldAllowOpeningMultipleExamples,
    prefix,
    articleUrlFormat,
  }) => {
    const [openIds, setOpenIds] = useState(() => {
      const openedExamples = data ? data.filter((example) => example.open) : [];
      return openedExamples.map((example, index) => index);
    });
    const { logger } = React.useContext(LoggerContext);
    const { store } = React.useContext(StoreContext);

    const sendOpenCloseExamplesBiEvent = (exampleId) => {
      const fullArticlePath = `/${prefix}/${articleUrlFormat}`;
      const action = openIds.includes(exampleId)
        ? TOGGLE_EXAMPLES_ACTIONS.CLOSE
        : TOGGLE_EXAMPLES_ACTIONS.OPEN;
      logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(examplesOpenClose, {
        action,
        articleName: getArticleNameFromPathname(fullArticlePath, store),
        articleUrl: fromRelativeUrlToAbsoluteUrl(
          fullArticlePath,
          window.location.origin,
          store,
        ),
        categoryName: getCategoryNameFromPathname(prefix, store),
        exampleId,
      });
    };

    const toggleRow = (id) => {
      const examples = [...openIds];
      const shouldCloseExample = openIds.includes(id);
      let newOpenedExamples = [];
      if (shouldCloseExample) {
        newOpenedExamples = examples.filter((exampleId) => exampleId !== id);
      } else {
        newOpenedExamples = shouldAllowOpeningMultipleExamples
          ? [...openIds, id]
          : [id];
      }
      setOpenIds(newOpenedExamples);
      sendOpenCloseExamplesBiEvent(id);
    };

    return (
      <div data-hook={dataHook}>
        {data &&
          data.map((row, index) => (
            <React.Fragment key={index}>
              <AccordionItem
                dataHook="accordion-item"
                id={index}
                toggleRow={toggleRow}
                {...row}
                isOpen={openIds.indexOf(index) !== -1}
                prefix={prefix}
              />
            </React.Fragment>
          ))}
      </div>
    );
  },
);

Accordion.displayName = 'Accordion';

Accordion.propTypes = {
  dataHook: PropTypes.string,
  shouldAllowOpeningMultipleExamples: PropTypes.bool,
  prefix: PropTypes.string,
  articleUrlFormat: PropTypes.string,

  /** accordion data nodes */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      content: PropTypes.node,
      open: PropTypes.bool,
    }),
  ),
};
